"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _slider = require("baseui/slider");

var _checkbox = require("baseui/checkbox");

var _button = require("baseui/button");

var _buttonGroup = require("baseui/button-group");

var _select = require("baseui/select");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UI = function (_React$Component) {
  _inherits(UI, _React$Component);

  var _super = _createSuper(UI);

  function UI(props) {
    var _this;

    _classCallCheck(this, UI);

    _this = _super.call(this, props);
    _this.state = {
      checks: []
    };
    return _this;
  }

  _createClass(UI, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          sublist = _this$props.sublist,
          suggested = _this$props.suggested,
          _onChange = _this$props.onChange,
          steps = _this$props.steps;
      if (!title || !sublist || sublist.length === 0) return null;
      var new_checks = this.state.checks;
      var ui_name = suggested || (0, _utils.suggestUIforNumber)(sublist.length);
      var ui_returned = null;

      if (ui_name === "checkbox") {
        ui_returned = _react["default"].createElement(_react["default"].Fragment, null, sublist.map(function (each, i) {
          return _react["default"].createElement(_checkbox.Checkbox, {
            key: each,
            checked: _this2.state.checks[i],
            value: each,
            onChange: function onChange() {
              new_checks[i] = !new_checks[i];

              _this2.setState({
                checks: new_checks
              });
            }
          }, each);
        }));
      } else if (ui_name === "slider" && parseInt(sublist[0])) {
        var s = sublist;
        ui_returned = _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_slider.Slider, {
          value: this.state.value || [s[0]],
          min: parseInt(s[0]),
          max: parseInt(s[s.length - 1]),
          step: steps || 1,
          onChange: function onChange(_ref) {
            var value = _ref.value;

            _this2.setState({
              value: value
            });

            typeof _onChange === 'function' && _onChange(value[0]);
          }
        }), title);
      } else if (ui_name === "buttongroups") {
        ui_returned = _react["default"].createElement(_react["default"].Fragment, null, "Checkbox Mode StatefulButtonGroup", _react["default"].createElement(_buttonGroup.StatefulButtonGroup, {
          mode: "checkbox",
          initialState: {
            selected: [0]
          }
        }, sublist.map(function (each, i) {
          return _react["default"].createElement(_button.Button, {
            key: each + "-" + i,
            value: each,
            onClick: function onClick(e) {
              return console.log(e.target.value);
            }
          }, each);
        })));
      } else {
        ui_returned = _react["default"].createElement(_select.StatefulSelect, {
          options: sublist.map(function (each) {
            return {
              id: each
            };
          }),
          labelKey: "id",
          placeholder: "Choose " + (0, _utils.humanize)(title),
          type: _select.TYPE.search,
          onChange: function onChange(event) {
            return console.log(event && event.value[0] && event.value[0].id);
          }
        });
      }

      return ui_returned;
    }
  }]);

  return UI;
}(_react["default"].Component);

exports["default"] = UI;